import GenericGridCreator from 'ps-components/AdvancedTable/GenericGrid/GenericGridCreator';

const newGenericGrid = new GenericGridCreator(
  'BULK_PRICING',
  {},
  {},
  {
    getInstanceState: (store: any) => store.marketPricing.BulkPricing.SurveyLibrary
  }
);

export const bulkPricingGridActions = newGenericGrid.getActions();

export default newGenericGrid.createReducer();
